export default "__VITE_ASSET__ee7e2e24__"